import React from 'react'

export const PercentTextField = ({
  source,
  record,
  className,
  multiplier = 1,
  ...props
}) => {
  const value = record[source] * multiplier
  return (
    <div className={className} {...props}>
      <span>{value.toFixed(2)}&nbsp;%</span>
    </div>
  )
}
